<template>
  <div class="statis-page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="80px">
        <!-- 开始日期 -->
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="queryParams.startYear"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            style="width:150px"
            :picker-options="pickerOptionsStart"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 结束日期 -->
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="queryParams.endYear"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            style="width:150px"
            :picker-options="pickerOptionsEnd"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 操作 -->
          <el-button type="primary" size="small" @click="getBoardData"
            >查询</el-button
          >
          <el-button type="primary" plain size="small" @click="handleResetQuery"
            >重置</el-button
          >
      </el-form>
    </div>
    <!-- 看板内容 -->
    <div class="board-container">
      <div class="container-row2">
        <div class="bar-box">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">问题汇总</div>
            </div>

          </div>
        </div>
        <div>
          <el-table border stripe highlight-current-row :data="[questionCountStatisTableData]">
            <el-table-column prop="allQuestionNum" label="问题总数" min-width="120px" align="center" />
            <el-table-column prop="hasBrevityMeasure" label="已有临时措施" min-width="120px" align="center" />
            <el-table-column prop="notHasBrevityMeasure" label="暂无临时措施" min-width="120px" align="center" />
            <el-table-column prop="qualityMeasure" label="质量整改" min-width="120px" align="center" />
            <el-table-column prop="hasScheme" label="已有根因" min-width="120px" align="center" />
            <el-table-column prop="hasEndTime" label="已断点" min-width="120px" align="center" />
            <el-table-column prop="closed" label="已关闭" min-width="120px" align="center" />
          </el-table>
        </div>
      </div>
      <div class="container-row4">

        <div class="pie-box">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">问题统计</div>
            </div>
            <!-- 切换按钮 -->
            <div class="bar-box-top">
              <div class="change-btn">
                <div style="margin-right:10px">
                  <el-select
                    filterable
                    v-model="queryParams.questionCountCountry"
                    placeholder="全部国家"
                    @change="getQuestionStatisTableData()"
                    clearable
                    size="mini"
                  >
                    <el-option
                      v-for="item in nationList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select
                    filterable
                    v-model="queryParams.questionCountCarModel"
                    placeholder="全部车型"
                    clearable
                    size="mini"
                    @change="getQuestionStatisTableData()"
                  >
                    <el-option
                      v-for="item in carTypeList"
                      :key="item.code"
                      :label="item.value"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  :class="[
                  'btn btn-first',
                  { active: questionStatisShow === 'time' }
                ]"
                  @click="showQuestionStatisByTime"
                >
                  按时间
                </div>
                <div
                  :class="[
                  'btn btn-last',
                  { active: questionStatisShow === 'account' }
                ]"
                  @click="showQuestionStatisByAccount"
                >
                  按责任单位
                </div>
              </div>

            </div>
          </div>
          <div>
            <div v-if="questionStatisShow == 'time'">
              <el-table border stripe highlight-current-row :data="questionStatisTableData">
                <el-table-column prop="提交月份" label="月份" min-width="120px" align="center"/>
                <el-table-column prop="已关闭" label="已关闭" min-width="120px" align="center"/>
                <el-table-column prop="进行中" label="进行中" min-width="120px" align="center"/>
                <el-table-column prop="总问题数量" label="总问题数量" min-width="120px" align="center"/>
              </el-table>
            </div>
            <div v-else>
              <el-table border stripe highlight-current-row :data="questionStatisTableData">
                <el-table-column prop="责任单位" label="责任单位" min-width="120px" align="center"/>
                <el-table-column prop="S" label="S" min-width="120px" align="center"/>
                <el-table-column prop="A" label="A" min-width="120px" align="center"/>
                <el-table-column prop="B" label="B" min-width="120px" align="center"/>
                <el-table-column prop="C" label="C" min-width="120px" align="center"/>
                <el-table-column prop="总计" label="总计" min-width="120px" align="center"/>
              </el-table>
            </div>

          </div>
        </div>
      </div>
      <div class="container-row1">
        <!-- 反馈问题统计 -->
        <div class="pie-box" style="border-right: 5px solid var(--content-bgColor);">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">反馈问题统计</div>
            </div>
            <div>
              <el-select
                filterable
                v-model="questionCarModel"
                placeholder="全部车型"
                clearable
                size="mini"
                @change="getQuestionStatis()"
              >
                <el-option
                  v-for="item in carTypeList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="pie-row">
            <div class="pie">
              <chart ref="carType" :height="160" :option="carTypeOption()" />
            </div>
            <div class="pie">
              <chart
                ref="carAttribute"
                :height="160"
                :option="carAttributeOption()"
              />
            </div>
          </div>
        </div>
        <!-- 故障类型分布 -->
        <div class="pie-box" style="border-left: 5px solid var(--content-bgColor);">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">零部件类型分布</div>
            </div>
            <div>
              <el-select
                filterable
                v-model="queryParams.carModel"
                placeholder="全部车型"
                clearable
                size="mini"
                @change="getFaultTypeStatis()"
              >
                <el-option
                  v-for="item in carTypeList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 故障来源切换按钮 -->
          <div class="bar-box-top">
            <div class="change-btn">
              <div
                :class="[
                  'btn btn-first',
                  { active: otherQueryParam.faultType === 0 }
                ]"
                @click="changeSelected('faultType', 0, getFaultTypeStatis)"
              >
                售前车
              </div>
              <div
                :class="[
                  'btn btn-last',
                  { active: otherQueryParam.faultType === 1 }
                ]"
                @click="changeSelected('faultType', 1, getFaultTypeStatis)"
              >
                售后车
              </div>
            </div>
          </div>
          <div>
            <chart ref="faultType" :height="160" :option="faultTypeOption()" />
          </div>
        </div>
      </div>
<!--
      <div class="container-row2">
        &lt;!&ndash; 问题处理情况 &ndash;&gt;
        <div class="pie-box">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">问题处理情况</div>
            </div>
          </div>
          &lt;!&ndash; 故障来源切换按钮 &ndash;&gt;
          <div class="bar-box-top">
            <div class="change-btn">
              <div
                :class="[
                  'btn btn-first',
                  { active: otherQueryParam.questionHandle === 0 }
                ]"
                @click="
                  changeSelected('questionHandle', 0, getQuestionHandleStatis)
                "
              >
                售前车
              </div>
              <div
                :class="[
                  'btn btn-last',
                  { active: otherQueryParam.questionHandle === 1 }
                ]"
                @click="
                  changeSelected('questionHandle', 1, getQuestionHandleStatis)
                "
              >
                售后车
              </div>
            </div>
          </div>
          <div class="pie-row">
            <div class="pie">
              <chart ref="status" :height="160" :option="statusOption()" />
            </div>
            <div class="pie">
              <chart
                ref="importantType"
                :height="160"
                :option="importantTypeOption()"
              />
            </div>
          </div>
        </div>
        &lt;!&ndash; 待处理问题统计 &ndash;&gt;
        <div class="pie-box" style="border-left: 5px solid #efefef;">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">待处理问题统计</div>
            </div>
          </div>
          &lt;!&ndash; 故障来源切换按钮 &ndash;&gt;
          <div class="bar-box-top">
            <div class="change-btn">
              <div
                :class="[
                  'btn btn-first',
                  { active: otherQueryParam.questionPending === 0 }
                ]"
                @click="
                  changeSelected('questionPending', 0, getQuestionPendingStatis)
                "
              >
                售前车
              </div>
              <div
                :class="[
                  'btn btn-last',
                  { active: otherQueryParam.questionPending === 1 }
                ]"
                @click="
                  changeSelected('questionPending', 1, getQuestionPendingStatis)
                "
              >
                售后车
              </div>
            </div>
          </div>
          <div style="padding-right:50px">
            <chart
              ref="questionPending"
              :height="160"
              :option="questionPendingOption()"
            />
          </div>
        </div>
      </div>
-->

      <div class="container-row3">
        <!-- 问题处理时效排行 -->
        <div class="bar-box">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">问题处理时效排行</div>
            </div>
            <div>
              <el-select
                filterable
                v-model="queryParams.roleId"
                placeholder="所有角色"
                clearable
                size="mini"
                @change="getAuditTimeStatis()"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                >
                </el-option>
              </el-select>
              <el-select
                filterable
                v-model="queryParams.faultType"
                placeholder="全部零部件类型"
                clearable
                size="mini"
                @change="getAuditTimeStatis()"
              >
                <el-option
                  v-for="item in faultTypeList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 切换按钮 -->
          <div class="bar-box-top">
            <div class="change-btn">
              <div
                :class="[
                  'btn btn-first',
                  { active: otherQueryParam.auditTime === 0 }
                ]"
                @click="changeSelected('auditTime', 0, getAuditTimeStatis)"
              >
                最低
              </div>
              <div
                :class="[
                  'btn btn-center',
                  { active: otherQueryParam.auditTime === 1 }
                ]"
                @click="changeSelected('auditTime', 1, getAuditTimeStatis)"
              >
                最高
              </div>
              <div
                :class="[
                  'btn btn-last',
                  { active: otherQueryParam.auditTime === 2 }
                ]"
                @click="changeSelected('auditTime', 2, getAuditTimeStatis)"
              >
                平均
              </div>
            </div>
            <div class="change-btn">
              <div
                :class="[
                  'btn btn-first',
                  { active: questionTimelinessType === 'minute' }
                ]"
                @click="changeToTimeUnitShow('minute')"
              >
                分钟
              </div>
              <div
                :class="[
                  'btn btn-center',
                 { active: questionTimelinessType === 'hour' }
                ]"
                @click="changeToTimeUnitShow('hour')"
              >
                小时
              </div>
              <div
                :class="[
                  'btn btn-last',
                 { active: questionTimelinessType === 'day' }
                ]"
                @click="changeToTimeUnitShow('day')"
              >
                天
              </div>
            </div>
            <div>单位：{{questionTimelinessType === "minute"?"分钟" : questionTimelinessType === "hour"?"小时":"天"}}</div>
          </div>
          <div>
            <chart ref="auditTime" :height="400" :option="auditTimeOption()" />
          </div>
        </div>
        <!-- 问题来源国家统计 -->
<!--        <div class="bar-box" style="border-left: 5px solid #efefef;">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">问题来源国家统计</div>
            </div>
            <div>
              <el-select
                filterable
                v-model="queryParams.carModel2"
                placeholder="全部车型"
                clearable
                size="mini"
                @change="getSourceCountryStatis()"
              >
                <el-option
                  v-for="item in carTypeList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div>
            <chart
              ref="sourceCountry"
              :height="400"
              :option="sourceCountryOption()"
            />
          </div>
        </div>-->
      </div>
      <!-- 本年问题增减趋势 -->
      <div class="container-row5">
        <div class="container-title-box">
          <div class="title-box">
            <div class="line"></div>
            <div class="title">本年问题增减趋势</div>
          </div>
          <div class="search-box">
            <el-button
              size="mini"
              type="text"
              @click="handleMore"
              >查看更多</el-button
            >
            <el-select
              filterable
              v-model="queryParams.carModel3"
              placeholder="全部车型"
              clearable
              size="mini"
              @change="getTrendStatis()"
            >
              <el-option
                v-for="item in carTypeList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <chart ref="trend" :height="400" :option="trendOption()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chart from "@/components/chart";
import {
  getQuestionStatisApi,
  getFaultTypeStatisApi,
  getQuestionHandleStatisApi,
  getQuestionPendingStatisApi,
  getAuditTimeStatisApi,
  getSourceCountryStatisApi,
  getFaultTaxStatisApi,
  getTrendStatisApi, requestQuestionStatisTableAccountData
} from "@/api/feedback";
import { getDictItem } from "@/util/dict";
import {requestQuestionAllCountData, requestQuestionStatisTableData} from "../../../api/feedback";
import {getSession} from "../../../util/localStor";
import {roleList} from "../../../api/api";

// （柱状 | 折现）图
function getBarChartOption(config = {}) {
  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    legend: {
      show: config.legend,
      data: config.legend
    },
    grid: config.grid,
    xAxis: {
      type: config.xAxisType,
      axisLabel: {
        formatter: config.xformatter || config.formatter
      },
      data: config.xAxis
    },
    yAxis: {
      type: config.yAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.yAxis
    },
    series: config.series
  };
}
// 饼图
function getPieChartOption(config = {}, seriesData = []) {
  return {
    // 悬浮提示
    tooltip: {
      appendToBody: true,
      trigger: "item"
    },
    // 中间文本
    graphic: {
      type: "text",
      left: "center",
      top: "center",
      style: {
        text: config.total, // 显示文本
        textAlign: "center",
        fill: "#000",
        fontSize: 20
      }
    },
    // 图例
    legend: {
      show: config.legendShow,
      orient: "vertical", // 竖向展示
      left: "right", // 整体靠右
      icon: "circle", // 图标样式
      align: "left", // 图标在左
      itemGap: 3, // 间距
      top: "center" // 垂直居中
    },
    series: [
      {
        type: "pie",
        radius: config.radius, // 饼图占比
        itemStyle: {
          normal: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 1,
            color: function(params) {
              // 定制颜色，params.dataIndex 为当前数据项的索引
              var colorList = config.colorList;
              return colorList[params.dataIndex];
            }
          }
        },
        label: {
          show: config.labelShow,
          formatter: "{b}\n{c}"
        },
        data: seriesData
      }
    ]
  };
}

export default {
  components: { chart },
  data() {
    return {
      nationList:[],
      roleList:[],
      questionStatisShow: "time",
      questionStatisTableData:[],
      questionCountStatisTableData:{},
      carTypeList: [], // 车型
      faultTypeList: [], // 故障类型
      questionTimelinessType:"minute",
      // 日期选择器限制
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.queryParams.endYear) {
            return time.getTime() > new Date(this.queryParams.endYear).getTime();
          }
          return false;
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.queryParams.startYear) {
            return time.getTime() < new Date(this.queryParams.startYear).getTime();
          }
          return false;
        }
      },
      // 查询参数
      queryParams: {
        startYear: "",
        endYear: "",
        roleId:"",
        questionCountCountry:"",
        questionCountCarModel:"",
      },
      questionCarModel:"",
      otherQueryParam: {
        faultType: 0, // 故障类型分布: 0-售前车，1-售后车
        questionHandle: 0, // 问题处理情况: 0-售前车，1-售后车
        questionPending: 0, // 待处理问题统计: 0-售前车，1-售后车
        auditTime: 2 // 问题处理时效排行: 0-最低，1-最高，2-平均
      },
      questionStatis: {}, // 反馈问题统计
      faultTypeStatis: {}, // 故障类型分布
      questionHandleStatis: {}, // 问题处理情况
      questionPendingStatis: {}, // 待处理问题统计
      auditTimeStatis: {}, // 问题处理时效排行
      sourceCountryStatis: {}, // 问题来源国家统计
      tableLoading: false, // 售前车订单故障率表格加载
      faultTaxStatis: {}, // 售前车订单故障率
      trendStatis: {} // 问题增减趋势
    };
  },
  created() {
    this.getCarTypeList(); // 获取车型列表
    this.getFaultTypeList(); // 获取故障类别列表
    this.getBoardData(); // 获取看板数据
    this.getTrendStatis(); // 获取本年问题增减趋势
    this.getQuestionAllCountData();
    this.getQuestionStatisTableData();
  },
  methods: {
    changeToTimeUnitShow(timeUnit){
      this.questionTimelinessType = timeUnit;
      this.getAuditTimeStatis();
    },
    //获取总的问题统计数据
    async getQuestionAllCountData() {
        const params = {
          startYear: this.queryParams.startYear
            ? this.queryParams.startYear
            : "",
          endYear: this.queryParams.endYear
            ? this.queryParams.endYear
            : "",
        }
        let res = await requestQuestionAllCountData({ data: params });
        // 如果没有查询到数据，展示为0
        if (!res.data || Object.keys(res.data).length === 0) {
          this.questionCountStatisTableData = {
            allQuestionNum: 0,
            hasBrevityMeasure: 0,
            notHasBrevityMeasure: 0,
            qualityMeasure: 0,
            hasScheme: 0,
            hasEndTime: 0,
            closed: 0
          };
        } else {
          this.questionCountStatisTableData = res.data;
        }
    },
    //获取问题统计报表
    async getQuestionStatisTableData() {
      let params = {
        startYear: this.queryParams.startYear || "",
        endYear: this.queryParams.endYear || "",
        questionType: this.questionStatisShow === "time" ? "1" :"2",
        questionCountCountry: this.queryParams.questionCountCountry,
        questionCountCarModel: this.queryParams.questionCountCarModel
      };
      let res
      if (this.questionStatisShow == "time"){
        res =  await requestQuestionStatisTableData(params);
      } else {
        res =  await requestQuestionStatisTableAccountData(params);
      }
      this.questionStatisTableData = res.data;
    },

    async getQuestionStatisTableAccountData() {
      let params = {
        startYear: this.queryParams.startYear,
        endYear: this.queryParams.endYear,
        questionType: this.questionStatisShow === "time" ? "1" :"2",
        questionCountCountry: this.queryParams.questionCountCountry,
        questionCountCarModel: this.queryParams.questionCountCarModel
      };
      let res = await requestQuestionStatisTableAccountData(params);
      this.questionStatisTableData = res.data;
    },


    // 获取车型列表
    async getCarTypeList() {
      this.carTypeList = await getDictItem("carType");
    },
    // 获取故障类别列表
    async getFaultTypeList() {
      this.faultTypeList = await getDictItem("badTypeList2");
      this.faultTypeList = this.faultTypeList.concat(
        await getDictItem("badTypeList1")
      );
      // 过滤重复项
      this.faultTypeList = this.faultTypeList.filter((obj, index, self) => {
        return index === self.findIndex(o => o.code === obj.code);
      });
    },

    // 获取反馈问题统计
    async getQuestionStatis() {
      this.$refs.carType?.myChart.showLoading();
      this.$refs.carAttribute?.myChart.showLoading();
      try {
        const queryParams = {
          startYear: this.queryParams.startYear || "",
          endYear: this.queryParams.endYear || "",
          carModel:this.questionCarModel !== null ?this.questionCarModel:""
        };
        const res = await getQuestionStatisApi({ data: queryParams });
        this.questionStatis = res.data || {};
      } catch (error) {}
      this.$refs.carType?.myChart.hideLoading();
      this.$refs.carAttribute?.myChart.hideLoading();
    },
    // 统计图:反馈问题统计-故障来源
    carTypeOption() {
      const config = {
        labelShow: true,
        radius: ["70%", "50%"],
        colorList: ["#68BBC4", "#5087EC"],
        total: this.questionStatis.total || 0
      };
      const seriesData = this.questionStatis.dataList2 || [];
      return getPieChartOption(config, seriesData);
    },
    // 统计图:反馈问题统计-车辆属性
    carAttributeOption() {
      const config = {
        labelShow: true,
        radius: ["70%", "50%"],
        colorList: ["#D97559", "#E4C477"],
        total: this.questionStatis.total || 0
      };
      const seriesData = this.questionStatis.dataList || [];
      return getPieChartOption(config, seriesData);
    },

    // 获取故障类型分布
    async getFaultTypeStatis() {
      this.$refs.faultType?.myChart.showLoading();
      try {
        const queryParams = {
          startYear: this.queryParams.startYear || "",
          endYear: this.queryParams.endYear || "",
          carModel: this.queryParams.carModel,
          carType: this.otherQueryParam.faultType
        };
        const res = await getFaultTypeStatisApi({ data: queryParams });
        this.faultTypeStatis = res.data || {};
      } catch (error) {}
      this.$refs.faultType?.myChart.hideLoading();
    },
    // 统计图:故障类型分布统计图
    faultTypeOption() {
      const config = {
        legendShow: true,
        radius: "70%",
        colorList: [
          "#5087EC",
          "#29BE7E",
          "#41C4FF",
          "#F2BD42",
          "#FF0000",
          "#7728F5",
          "#DE868F",
          "#BFBF3D"
        ]
      };
      const seriesData = this.faultTypeStatis.dataList;
      return getPieChartOption(config, seriesData);
    },

    // 获取问题处理情况
    async getQuestionHandleStatis() {
      this.$refs.status?.myChart.showLoading();
      this.$refs.importantType?.myChart.showLoading();
      try {
        const queryParams = {
          startYear: this.queryParams.startYear || "",
          endYear: this.queryParams.endYear || "",
          carType: this.otherQueryParam.questionHandle
        };
        const res = await getQuestionHandleStatisApi({ data: queryParams });
        this.questionHandleStatis = res.data || {};
      } catch (error) {}
      this.$refs.status?.myChart.hideLoading();
      this.$refs.importantType?.myChart.hideLoading();
    },
    // 统计图:问题处理情况-状态
    statusOption() {
      const config = {
        legendShow: true,
        radius: ["70%", "50%"],
        colorList: ["#FF0000", "#29BE7E", "#FCCA00", "#1890FF", "#BFBF3D"],
        total: this.questionHandleStatis.total || 0
      };
      const seriesData = this.questionHandleStatis.dataList;
      return getPieChartOption(config, seriesData);
    },
    // 统计图:问题处理情况-重点问题
    importantTypeOption() {
      const config = {
        legendShow: true,
        radius: "70%",
        colorList: ["#FF0000", "#68BBC4"]
      };
      const seriesData = this.questionHandleStatis.dataList2;
      return getPieChartOption(config, seriesData);
    },

    // 获取待处理问题统计
    async getQuestionPendingStatis() {
      this.$refs.questionPending?.myChart.showLoading();
      try {
        const queryParams = {
          startYear: this.queryParams.startYear || "",
          endYear: this.queryParams.endYear || "",
          carType: this.otherQueryParam.questionPending
        };
        const res = await getQuestionPendingStatisApi({ data: queryParams });
        this.questionPendingStatis = { dataList: res.data || [] };
      } catch (error) {}
      this.$refs.questionPending?.myChart.hideLoading();
    },
    // 统计图:待处理问题统计
    questionPendingOption() {
      const config = {
        legendShow: true,
        radius: "70%",
        colorList: [
          "#5087EC",
          "#68BBC4",
          "#58A55C",
          "#F2BD42",
          "#EE752F",
          "#D95040",
          "#7728F5"
        ]
      };
      const seriesData = this.questionPendingStatis.dataList;
      return getPieChartOption(config, seriesData);
    },
    async getRoleList(){
      let query = {
        data: {staffAccountNum: "", staffName: "", staffRole: ""},
        page: {
          pageNum: 1,
          pageSize: 100
        }
      };
      roleList(query).then(res => {
        this.roleList = res.data.records;
      })
    },
    // 获取问题处理时效排行
    async getAuditTimeStatis() {
      this.$refs.auditTime?.myChart.showLoading();
      try {
        const queryParams = {
          startYear: this.queryParams.startYear || "",
          endYear: this.queryParams.endYear || "",
          faultType: this.queryParams.faultType,
          codeType: this.otherQueryParam.auditTime,
          timeType: this.questionTimelinessType,
          roleId: this.queryParams.roleId !== null ? this.queryParams.roleId : ""
        };
        const res = await getAuditTimeStatisApi({ data: queryParams });
        let yAxis = [];
        let dataList = [];
        res.data?.map(item => {
          yAxis.push(item.taskName);

          if (this.otherQueryParam.auditTime == 0){ // 最低
            dataList.push(item.minDuration);
          } else if (this.otherQueryParam.auditTime == 1){ // 最高
            dataList.push(item.maxDuration);
          }else { // 平均
            dataList.push(item.avgDuration);
          }


        });
        this.auditTimeStatis = { yAxis, dataList };
      } catch (error) {}
      this.$refs.auditTime?.myChart.hideLoading();
    },
    // 统计图:问题处理时效排行
    auditTimeOption() {
      const config = {
        grid: { left: 120, top: 20, right: 50, bottom: 50 },
        xAxisType: "value",
        yAxisType: "category",
        formatter: function(value) {
          return value.length > 8 ? value.substring(0, 8) + '...' : value;
        },
        xformatter: "{value}" + (this.questionTimelinessType === "minute"? "min":this.questionTimelinessType === "hour"? "hour":"day"),
        yAxis: this.auditTimeStatis.yAxis,
        series: [
          {
            name: "处理时长",
            type: "bar",
            color: "#5087EC",
            data: this.auditTimeStatis.dataList,
            barCategoryGap: "50%" // 类目间隔设置为类目宽度的50%
          }
        ]
      };
      return getBarChartOption(config);
    },

    // 获取问题来源国家统计
    async getSourceCountryStatis() {
      this.$refs.sourceCountry?.myChart.showLoading();
      try {
        const queryParams = {
          startYear: this.queryParams.startYear || "",
          endYear: this.queryParams.endYear || "",
          carModel: this.queryParams.carModel2
        };
        const res = await getSourceCountryStatisApi({ data: queryParams });
        let yAxis = [];
        let dataList = [];
        let dataList2 = [];
        res.data?.map(item => {
          yAxis.push(item.name);
          dataList.push(item.total);
          dataList2.push(item.closeTotal);
        });
        this.sourceCountryStatis = { yAxis, dataList, dataList2 };
      } catch (error) {}
      this.$refs.sourceCountry?.myChart.hideLoading();
    },
    // 统计图:问题来源国家统计
    sourceCountryOption() {
      const config = {
        grid: { bottom: 20 },
        xAxisType: "category",
        yAxisType: "value",
        xAxis: this.sourceCountryStatis.yAxis,
        series: [
          {
            name: "反馈问题",
            type: "bar",
            color: "#5087EC",
            data: this.sourceCountryStatis.dataList,
            barCategoryGap: "50%", // 类目间隔设置为类目宽度的50%
            barGap: "0" // 系列间隔
          },
          {
            name: "已关闭问题",
            type: "bar",
            color: "#0EC98E",
            data: this.sourceCountryStatis.dataList2,
            barCategoryGap: "50%", // 类目间隔设置为类目宽度的50%
            barGap: "0" // 系列间隔
          }
        ]
      };
      return getBarChartOption(config);
    },

    // 获取售前车订单故障率
    async getFaultTaxStatis() {
      if (!this.queryParams.orderNum) {
        return;
      }
      this.tableLoading = true;
      try {
        const queryParams = {
          orderNum: this.queryParams.orderNum
        };
        const res = await getFaultTaxStatisApi({ data: queryParams });
        this.faultTaxStatis = {
          dataList: res.data && res.data.orderNum ? [res.data] : []
        };
      } catch (error) {}
      this.tableLoading = false;
    },

    // 获取本年问题增减趋势
    async getTrendStatis() {
      this.$refs.trend?.myChart.showLoading();
      try {
        const queryParams = {
          carModel: this.queryParams.carModel3
        };
        const res = await getTrendStatisApi({ data: queryParams });
        let xAxis = [];
        let dataList = [];
        let dataList2 = [];
        for (let i = 1; i <= 12; i++) {
          const monthData = res.data?.find(item => {
            return item.month === i;
          });
          xAxis[i - 1] = i + "月";
          dataList[i - 1] = monthData ? monthData.total : 0;
          dataList2[i - 1] = monthData ? monthData.closeTotal : 0;
        }
        this.trendStatis = { xAxis, dataList, dataList2 };
      } catch (error) {}
      this.$refs.trend?.myChart.hideLoading();
    },
    // 统计图:本年问题增减趋势
    trendOption() {
      const config = {
        legend: ["反馈问题", "已关闭问题"],
        xAxisType: "category",
        yAxisType: "value",
        xAxis: this.trendStatis.xAxis,
        series: [
          {
            name: "反馈问题",
            type: "line",
            color: "#5087EC",
            data: this.trendStatis.dataList
          },
          {
            name: "已关闭问题",
            type: "line",
            color: "#0EC98E",
            data: this.trendStatis.dataList2
          }
        ]
      };
      return getBarChartOption(config);
    },
    // 查看更多
    handleMore() {
      this.$router.push("/dataStatis/moreBoard");
    },

    // 获取看板数据
    getBoardData() {
      this.getQuestionStatis(); // 获取反馈问题统计
      this.getFaultTypeStatis(); // 获取故障类型分布
      this.getQuestionHandleStatis(); // 获取问题处理情况
      this.getQuestionPendingStatis(); // 获取待处理问题统计
      this.getAuditTimeStatis(); // 获取问题处理时效排行
      this.getSourceCountryStatis(); // 获取问题来源国家统计
      this.getQuestionAllCountData(); // 问题汇总
      this.getQuestionStatisTableData(); // 问题统计
    },
    showQuestionStatisByTime(){
      this.questionStatisShow = "time"
      this.getQuestionStatisTableData();
    },
    showQuestionStatisByAccount(){
      this.questionStatisShow = "account"
      this.getQuestionStatisTableData();
    },
    // 查询条件切换
    changeSelected(field, val, getStatisFun) {
      this.otherQueryParam[field] = val;
      getStatisFun();
    },
    // 重置
    handleResetQuery() {
      this.queryParams = Object.assign({}, this.$options.data()?.queryParams);
      this.getBoardData();
    }
  },
  mounted() {
    this.nationList = Object.values(getSession('nationList'))
    this.getRoleList();
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.board-container > div {
  background-color: var(--dash-color);
  margin-bottom: 10px;
  padding: 15px;
}
.container-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;
  .title-box {
    display: flex;
  }
  .line {
    width: 4px;
    height: 20px;
    background-color: var(--theme-color);
    margin-right: 10px;
  }
  .title {
    line-height: 20px;
    color: #101010;
    font-size: 16px;
  }
  .search-box {
    display: flex;
    align-items: center;
  }
}
.board-container {
  .bar-box-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
  }
  .el-select {
    margin-left: 10px;
  }
  .change-btn {
    display: flex;
    height: 30px;

    .btn {
      color: var(--theme-color);
      border: 1px solid var(--theme-color);
      border-radius: 0;

    }
    .btn-first {
      border-radius: 4px 0 0 4px;
    }
    .btn-center {
      border-left: none;
      border-right: none;
    }
    .btn-last {
      border-radius: 0 4px 4px 0;
    }
    .active {
      color: #fff;
      background-color: var(--theme-color)
    }
  }
  .container-row1 {
    padding: 0;
    display: flex;
    .pie-box {
      position: relative;
      flex: 1;
      padding: 15px;
      .pie-row {
        display: flex;
        .pie {
          width: 50%;
        }
      }
    }
  }
}
::v-deep .el-table tbody tr:hover > td {
  background: #93d2f3 !important;
}
.el-button--text {
  color: var(--theme-color);
}
</style>
